function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Base from './base';
import _ from 'underscore';

var PaymentMethod = /*#__PURE__*/function (_Base) {
  _inheritsLoose(PaymentMethod, _Base);

  function PaymentMethod() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = PaymentMethod.prototype;

  _proto.urlRoot = function urlRoot() {
    return '/api/payment_methods';
  };

  _proto.lastFour = function lastFour() {
    var number = this.get('number');

    if (number) {
      return number.substr(number.length - 4);
    }
  };

  _proto.expirationMonth = function expirationMonth() {
    if (this.has('expiration_date')) {
      var month = this.get('expiration_date').split('/')[0];
      return parseInt(month, 10);
    }
  };

  _proto.expirationYear = function expirationYear() {
    if (this.has('expiration_date')) {
      var year = this.get('expiration_date').split('/')[1];
      return parseInt(year, 10);
    }
  };

  _proto.expirationDate = function expirationDate() {
    return new Date(this.expirationYear() + 2000, this.expirationMonth() - 1);
  } // TODO: move this to a base model?
  ;

  _proto.validate = function validate(attrs, options) {
    var errors = {};

    _.each(attrs, function (v, k) {
      if (_.isString(v) && !v.trim().length) {
        errors[k] = 'cannot be blank';
      } else if (_.isNull(v)) {
        errors[k] = 'cannot be null';
      } else if (_.isUndefined(v)) {
        errors[k] = 'cannot be undefined';
      } else if (_.isObject(v) && _.isEmpty(v)) {
        errors[k] = 'cannot be empty';
      }
    });

    if (_.isEmpty(errors)) {
      return null;
    } else {
      return errors;
    }
  };

  return PaymentMethod;
}(Base);

export { PaymentMethod as default };